/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Grid_System_TitleInputs */

const en_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character/Line Grid System`)
};

const fr_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Système de grille caractères/lignes`)
};

const de_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichen-/Linienrastersystem`)
};

const it_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema di griglia di caratteri/linee`)
};

const ru_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Система сетки символов/строк`)
};

const es_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema de cuadrícula de caracteres/líneas`)
};

const zh_cn2_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符/线网格系统`)
};

const ja_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字/行グリッドシステム`)
};

const hi_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षर/रेखा ग्रिड प्रणाली`)
};

const pt_pt2_options_display_grid_system_title = /** @type {(inputs: Options_Display_Grid_System_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema de grade de caracteres/linhas`)
};

/**
* | output |
* | --- |
* | "Character/Line Grid System" |
*
* @param {Options_Display_Grid_System_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_grid_system_title = /** @type {((inputs?: Options_Display_Grid_System_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Grid_System_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_grid_system_title(inputs)
	if (locale === "de") return de_options_display_grid_system_title(inputs)
	if (locale === "it") return it_options_display_grid_system_title(inputs)
	if (locale === "ru") return ru_options_display_grid_system_title(inputs)
	if (locale === "es") return es_options_display_grid_system_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_grid_system_title(inputs)
	if (locale === "ja") return ja_options_display_grid_system_title(inputs)
	if (locale === "hi") return hi_options_display_grid_system_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_grid_system_title(inputs)
	return en_options_display_grid_system_title(inputs)
});